import React from 'react';
import PropTypes from 'prop-types';

/**
 * The fake coach-mark cursor.
 *
 * A fixed-position pointer that glides to the centre of the highlighted element
 * (CSS transition on `transform`) and plays a ripple when the tour "clicks" —
 * then the real click is handed back to the user. It is purely decorative:
 * `pointer-events: none` in the stylesheet means it never intercepts the click
 * it is pointing at, and it is hidden from assistive tech.
 */
const AnimatedCursor = ({ point, pulsing, visible }) => {
  if (!point || !visible) return null;

  return (
    <div
      className={`tutorial-cursor${pulsing ? ' tutorial-cursor--pulsing' : ''}`}
      style={{ transform: `translate3d(${point.x}px, ${point.y}px, 0)` }}
      data-testid="tutorial-cursor"
      aria-hidden="true"
    >
      <span className="tutorial-cursor__ripple" />
      <svg
        className="tutorial-cursor__pointer"
        width="26"
        height="26"
        viewBox="0 0 24 24"
        focusable="false"
      >
        {/* Classic arrow pointer: white fill with a dark outline so it reads on
            both the dimmed backdrop and the bright spotlight cut-out. */}
        <path
          d="M5.5 2.5l12.2 8.3-5.1.6 3 6.2-2.6 1.3-3-6.2-3.2 3.6z"
          fill="#ffffff"
          stroke="#1f1f1f"
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

AnimatedCursor.defaultProps = {
  point: null,
  pulsing: false,
  visible: true,
};

AnimatedCursor.propTypes = {
  point: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }),
  pulsing: PropTypes.bool,
  visible: PropTypes.bool,
};

export default AnimatedCursor;
